import EmptyShipmentCard from './components/EmptyShipmentCard';
import { lazy, Suspense } from 'react';
import { LiveTrackingSectionProps } from './types';

const LiveTrackingCarousel = lazy(() => import('./components/LiveTrackingCarousel'));

const renderCarouselFallback = (itemsCount: number) => (
  <div
    aria-hidden="true"
    className="flex min-h-[190px] w-full flex-col gap-3"
  >
    <div className="flex gap-2 overflow-hidden py-0.5">
      {Array.from({ length: Math.min(itemsCount, 2) }, (_, index) => (
        <div
          className="h-[172px] w-[243px] shrink-0 animate-pulse rounded-2xl border border-border-strong bg-muted"
          key={index}
        />
      ))}
    </div>
    {itemsCount > 1 && (
      <div className="flex w-full items-center justify-center gap-1">
        <span className="h-1.5 w-5 rounded-full bg-muted" />
        <span className="size-1.5 rounded-full bg-muted" />
      </div>
    )}
  </div>
);

const LiveTrackingSection = (props: LiveTrackingSectionProps) => {
  const {
    isError,
    isLoading,
    items
  } = props;

  const hasShipments = items.length > 0;
  const emptyMessage = isError ? 'Поставки недоступны' : undefined;
  const isEmptyStateVisible = !hasShipments && !isLoading;

  return (
    <section className="flex w-full flex-col gap-4">
      <h2 className="font-sans text-lg font-semibold leading-6 text-foreground">Лайв трекинг</h2>
      {isEmptyStateVisible && <EmptyShipmentCard message={emptyMessage} />}
      {hasShipments && (
        <Suspense fallback={renderCarouselFallback(items.length)}>
          <LiveTrackingCarousel items={items} />
        </Suspense>
      )}
    </section>
  );
};

export default LiveTrackingSection;